module.exports = __webpack_public_path__ + "img/01_zhTc.4839b1e5.png";